import { tv } from "tailwind-variants";

const base = tv({
    base: "tw:font-bold tw:text-danger tw:block tw:w-fit",
    variants: {
        size: {
            xs: "tw:leading-2",
            sm: "tw:leading-4",
            md: "tw:leading-6",
            lg: "tw:leading-10",
            xl: "tw:leading-10"
        }
    },

    defaultVariants: {
        size: "md"
    }
});

const whole = tv({
    base: ["tw:after:content-[',']"],
    variants: {
        size: {
            xs: "tw:text-sm",
            sm: "",
            md: "tw:text-xl",
            lg: "tw:text-4xl",
            xl: "tw:text-4xl"
        }
    },
    defaultVariants: {
        size: "md"
    }
});

const decimal = tv({
    variants: {
        size: {
            xs: "tw:text-[0.7rem]",
            sm: "tw:text-xs",
            md: "tw:text-sm",
            lg: "tw:text-2xl",
            xl: "tw:text-2xl"
        }
    },

    defaultVariants: {
        size: "md"
    }
});

export const main = Object.assign(base, {
    whole: whole,
    decimal: decimal
});
